module.exports = __webpack_public_path__ + "media/icons/carouselArrowNext-41d0fe96.svg";